import React from "react";
import { site } from "../data/site";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/ui-blocks";
import { IMG } from "../data/site";

const P = ({ children }) => <p className="text-neutral-600 leading-relaxed mb-5">{children}</p>;
const H = ({ children }) => <h2 className="text-2xl mt-10 mb-3">{children}</h2>;

const Terms = () => (
  <div>
    <Seo title="Terms of Use" description="Terms of Use for the Premier Granite LLC website." path="/terms" image={IMG.graniteTexture} />
    <PageHero eyebrow="Legal" title="Terms of Use" image={IMG.stoneWhiteBrown} testid="terms-hero" />
    <section className="section bg-white">
      <div className="container-custom max-w-3xl">
        <P>Welcome to the {site.name} website. By using this website, you agree to the following terms.</P>

        <H>Informational Purpose</H>
        <P>The information on this website is provided for general informational purposes. It does not constitute a contractual quote or guarantee.</P>

        <H>Estimates</H>
        <P>Project estimates require individual review. Any pricing, scope or timeline is confirmed only after we review the specific details of your project.</P>

        <H>Materials & Imagery</H>
        <P>Natural stone and other materials vary in color, pattern and appearance from sample to sample and slab to slab. Website imagery is illustrative and may not represent a specific completed Premier Granite project unless clearly identified as such.</P>

        <H>Website Content</H>
        <P>Site content may not constitute a contractual quote and may be updated or changed at any time without notice.</P>

        <H>Contact</H>
        <P>Questions about these terms? Contact us at <a href={site.emailHref} className="text-[#CD1422] font-medium">{site.email}</a>.</P>

        <p className="text-sm text-neutral-400 mt-8">Last updated: {new Date().getFullYear()}.</p>
      </div>
    </section>
  </div>
);

export default Terms;
